
import * as handlebars_family from "../handlebars_family.js";
import "../layout/layout_modal.mustache";
const TPL = handlebars_family.addTemplate("modal/waitingpremium",{"1":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return " <div class=\"modal V4\"><div class=\"title\"> "
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalcongratulations.waiting",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":68},"end":{"line":1,"column":109}}})) != null ? stack1 : "")
    + " </div><div class=\"content\" style=\"text-align:justify\"><lottie-player autoplay loop mode=\"normal\" src=\"images/lottie/anim_clock.json\" style=\"width: 120px;margin-left: auto;margin-right: auto;display:block\" class=\"blockmargin\" ></lottie-player><p>"
    + ((stack1 = lookupProperty(helpers,"i18n").call(depth0 != null ? depth0 : (container.nullContext || {}),"modalcongratulations.waitingtext",{"name":"i18n","hash":{},"data":data,"loc":{"start":{"line":1,"column":355},"end":{"line":1,"column":400}}})) != null ? stack1 : "")
    + "</p></div></div> ";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return ((stack1 = container.invokePartial(lookupProperty(partials,"layout/layout_modal"),depth0,{"name":"layout/layout_modal","fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"helpers":helpers,"partials":partials,"decorators":container.decorators})) != null ? stack1 : "");
},"usePartial":true,"useData":true});
export default TPL;